import * as effects from 'redux-saga/effects';

import { Backend } from '../../Backend/Backend';
import { ICallState } from '../../Backend/Messages/callSuccess';
import { Logger } from '../../Utils/Logger';

import {
    getPlayerRapidSearch, getPlayerRapidSearchSuccess, getPlayerRapidSearchError,
    getPlayerPoliticalGroups, getPlayerPoliticalGroupsSuccess,
    getPlayerPersonsSuccess, getPlayerPersons, getPlayerAdvancedSearch,
    getAutocompleteEmission, getAutocompleteEmissionSuccess,
    getEmissionSearch, getEmissionSearchSuccess, getEmissionSearchError,
    getPlayerAdvancedSearchSuccess, getPlayerAdvancedSearchError
} from './Actions';

import {
    IPlayerActionTypes, IPlayerResults, IPlayerGroups, IPlayerRapidSearchFilters
} from './Types';

function* handleGetPlayerRapidSearch(action: ReturnType<typeof getPlayerRapidSearch>) {
    const backend = Backend.getInstance();

    let filters: IPlayerRapidSearchFilters = action.payload

    try {
        const res: ICallState = yield effects.apply(backend, backend.getPlayerRapidSearch, [filters]);
        if (res !== null && res.status_code === 200) {

            yield effects.put(getPlayerRapidSearchSuccess(res.results as IPlayerResults));
        }
    } catch (err) {
        yield effects.put(getPlayerRapidSearchError(err))
        Logger.warn('Failed getPlayerRapidSearch');
        alert(err.message)
    }
}

function* handleGetPlayerGroups(action: ReturnType<typeof getPlayerPoliticalGroups>) {
    const backend = Backend.getInstance();

    const res: ICallState = yield effects.apply(backend, backend.getPlayerPoliticalGroups, [action.payload] as any);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getPlayerPoliticalGroupsSuccess(res.results as IPlayerGroups[]));
        }
    } else {
        Logger.warn('Failed handleGetPlayerGroups');
    }
}
function* handleGetPlayerPersons(action: ReturnType<typeof getPlayerPersons>) {
    const backend = Backend.getInstance();

    const res: ICallState = yield effects.apply(backend, backend.getPlayerPersons, [action.payload] as any);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getPlayerPersonsSuccess(res.results as IPlayerGroups[]));
        }
    } else {
        Logger.warn('Failed handleGetPlayerPersons');
    }
}
function* handleGetPlayerAdvancedSearch(action: ReturnType<typeof getPlayerAdvancedSearch>) {
    const backend = Backend.getInstance();

    try {
        const res: ICallState = yield effects.apply(backend, backend.getPlayerAdvancedSearch, [action.payload as any]);
        if (res.status_code === 200) {

            if (res !== null) {
                yield effects.put(getPlayerAdvancedSearchSuccess(res.results as IPlayerResults));
            }
        } else {
            Logger.warn('Failed getPlayerAdvancedSearch');
        }
    } catch (err) {
        yield effects.put(getPlayerAdvancedSearchError(err))
        Logger.warn('Failed getPlayerAdvancedSearch');
        alert(err.message)
    }
}
function* handleGetEmissionAutocomplete(action: ReturnType<typeof getAutocompleteEmission>) {
    const backend = Backend.getInstance();
    
    const { emission_name, media_ids } = action.payload as { emission_name: string, media_ids?: number[] };
    
    // Toujours utiliser le nouvel endpoint avec media_ids si fourni
    // Sinon, utiliser l'endpoint classique (fallback)
    let res: ICallState;
    if (media_ids && media_ids.length > 0) {
        res = yield effects.apply(backend, backend.getAutocompleteEmissionByMedia, [emission_name, media_ids]);
    } else {
        res = yield effects.apply(backend, backend.getAutocompleteEmission, [emission_name]);
    }
    
    if (res.status_code === 200) {
        if (res !== null) {
            yield effects.put(getAutocompleteEmissionSuccess(res.results));
        }
    } else {
        Logger.warn('Failed handleGetEmissionAutocomplete');
    }
}
function* handleGetEmissionSearchResults(action: ReturnType<typeof getEmissionSearch>) {
    const backend = Backend.getInstance();

    try {
        const res: ICallState = yield effects.apply(backend, backend.playerEmissionSearch, [action.payload[0] as any]);
        if (res.status_code === 200) {

            if (res !== null) {
                yield effects.put(getEmissionSearchSuccess(res.results));
            }
        } else {
            Logger.warn('Failed handleGetEmissionSearchResults');
        }
    } catch (err) {
        yield effects.put(getEmissionSearchError(err))
        Logger.warn('Failed handleGetEmissionSearchResults');
        alert(err.message)
    }
}
function* watchPlayer() {
    yield effects.takeEvery(IPlayerActionTypes.GET_PLAYER_RAPID_SEARCH, handleGetPlayerRapidSearch);
    yield effects.takeEvery(IPlayerActionTypes.GET_PLAYER_GROUPS, handleGetPlayerGroups);
    yield effects.takeEvery(IPlayerActionTypes.GET_PLAYER_PERSONS, handleGetPlayerPersons);
    yield effects.takeEvery(IPlayerActionTypes.GET_PLAYER_ADVANCED_SEARCH, handleGetPlayerAdvancedSearch);
    yield effects.takeEvery(IPlayerActionTypes.GET_EMISSION_AUTOCOMPLETE, handleGetEmissionAutocomplete);
    yield effects.takeEvery(IPlayerActionTypes.GET_EMISSION_SEARCH, handleGetEmissionSearchResults);
}

export function* PlayerSaga() {
    yield effects.all([
        effects.fork(watchPlayer),
    ]);
}
